import { Component } from '@angular/core';
import { GamesGroupService, GroupType, LeaderboardType, PredictorGroupSummary } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-predictor-leaderboard-page',
  templateUrl: './predictor-leaderboard-page.component.html',
  styleUrls: ['./predictor-leaderboard-page.component.scss'],
})
export class PredictorLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.PredictorPoints;
  gamesGroup$: Observable<PredictorGroupSummary[]>;
  groupType = GroupType.Predictor;

  constructor(private gamesGroupService: GamesGroupService) {}
  ngOnInit(): void {
    this.gamesGroup$ = this.gamesGroupService.fetchPredictorGroups();
  }
}
